import React from 'react';
import { injectIntl } from 'react-intl';
import { Alert, Text } from '@universe/orion';
import { Label, Icon } from 'semantic-ui-react';
import locale from './locale';

export const ErrorRequiredField = injectIntl(({ intl: { formatMessage }, error, messageKey = 'errorRequired' }) => {
  if (!error) return null;
  return (
    <Label basic color="red">
      <Icon className="universe-exclamation" />
      {formatMessage(locale[messageKey])}
    </Label>
  );
});

export const ErrorFlashMessage = injectIntl(({ intl: { formatMessage }, errors, detailed }) => {
  if (!hasErrors(errors)) {
    return null;
  }

  const errorKeys = extractErrorKeys(errors);
  const messages = getErrorMessages(errorKeys, detailed, formatMessage, locale);
  return <ErrorMessage messages={messages} />;
});

const ErrorMessage = ({ messages }) => (
  <Alert variant="error">
    <Text>
      {messages.map(msg => (
        <p style={{ whiteSpace: 'pre-line' }} key={msg} id="error-message">
          {msg}
        </p>
      ))}
    </Text>
  </Alert>
);

export function hasErrors(errors) {
  if (!errors) return false;
  if (Array.isArray(errors) && errors.length === 0) return false;
  if (typeof errors === 'object' && !Array.isArray(errors) && Object.keys(errors).length === 0) return false;
  return true;
}

export function extractErrorKeys(errors) {
  if (Array.isArray(errors)) {
    return errors;
  }

  if (errors && typeof errors === 'object') {
    if (errors.obj && typeof errors.obj === 'object') {
      return Object.keys(errors.obj);
    }
    return Object.keys(errors);
  }

  return [];
}

// Accept locale as parameter
export function getErrorMessages(errorKeys, detailed, formatMessage, localeObj) {
  if (detailed) {
    const detailedMessages = errorKeys.filter(key => localeObj[key]).map(key => formatMessage(localeObj[key]));

    return detailedMessages.length > 0
      ? detailedMessages
      : [getDefaultMessage(errorKeys.length, formatMessage, localeObj)];
  }

  return [getDefaultMessage(errorKeys.length, formatMessage, localeObj)];
}

// Accept localeObj as parameter
export function getDefaultMessage(errorCount, formatMessage, localeObj) {
  return formatMessage(localeObj.errorFlash, { errorCount });
}
